import { createFileRoute, redirect } from "@tanstack/react-router";

/** Flyttad till ordlistan – permanent omdirigering. */
export const Route = createFileRoute("/savera")({
  beforeLoad: () => {
    throw redirect({ to: "/ordlista/$term", params: { term: "savera" }, statusCode: 301 });
  },
});
